import React from "react";
import {
  BrainIcon,
  ChartIcon,
  ChevronDownIcon,
  GlobeIcon,
  LockIcon,
  NetworkIcon,
  ShieldCheckIcon,
} from "../../Components/Icons";
import DgiLogo from "./DgiLogo";
import "./Auth.css";

const FEATURES = [
  {
    icon: <ShieldCheckIcon />,
    title: "Secure & Compliant",
    text: "Enterprise-grade security and data protection",
  },
  {
    icon: <NetworkIcon />,
    title: "Connected Ecosystem",
    text: "Integrated with key government data sources",
  },
  {
    icon: <BrainIcon />,
    title: "Intelligent Insights",
    text: "AI-powered risk detection and analytics",
  },
  {
    icon: <ChartIcon />,
    title: "Better Outcomes",
    text: "Improved compliance and operational efficiency",
  },
];

/**
 * Split-screen shell shared by every auth screen: DGI brand panel on the left,
 * language switcher / card slot / copyright on the right.
 */
export default function AuthLayout({ children }) {
  return (
    <div className="auth-page">
      <aside
        className="auth-brand"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/authbgimage.png)`,
        }}
      >
        <span className="auth-brand__scrim" />

        <div className="auth-brand__inner">
          <div className="auth-brand__identity">
            <DgiLogo width={92} />
            <span className="auth-brand__identity-divider" />
            <div>
              <p className="auth-brand__org">
                Direction Générale
                <br />
                Des Impôts
              </p>
              <p className="auth-brand__tagline">
                Building trust. Funding tomorrow.
              </p>
            </div>
          </div>

          <h1 className="auth-brand__title">
            DGI Smart
            <br />
            <span>Tax Registry</span>
          </h1>

          <p className="auth-brand__lede">
            A secure, connected and intelligent platform for taxpayer
            management, compliance and revenue optimization.
          </p>

          <div className="auth-brand__features">
            {FEATURES.map((feature) => (
              <div className="auth-feature" key={feature.title}>
                <span className="auth-feature__icon">{feature.icon}</span>
                <div>
                  <p className="auth-feature__title">{feature.title}</p>
                  <p className="auth-feature__text">{feature.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="auth-brand__notice">
            <LockIcon size={22} />
            <span>
              This is a government system. Unauthorized access is strictly
              prohibited and may be subject to legal action.
            </span>
          </div>
        </div>
      </aside>

      <main className="auth-panel">
        <div className="auth-panel__lang">
          <button type="button" className="auth-lang">
            <GlobeIcon size={16} />
            EN
            <ChevronDownIcon size={14} />
          </button>
        </div>

        <div className="auth-panel__body">{children}</div>

        <p className="auth-panel__footer">
          © {new Date().getFullYear()} DGI – Direction Générale des Impôts. All
          rights reserved.
        </p>
      </main>
    </div>
  );
}
